module.exports = __webpack_public_path__ + "img/v1.634d0771.png";